// extracted by mini-css-extract-plugin
export var section = "_2d-1";
export var topNav = "_2d-0";